// icon:arrow-right-short | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
import * as React from 'react'

function IconArrowRightShort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 16 16"
      height="1rem"
      width="1rem"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M4 8a.5.5 0 01.5-.5h5.793L8.146 5.354a.5.5 0 11.708-.708l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L10.293 8.5H4.5A.5.5 0 014 8z"
      />
    </svg>
  )
}

export default IconArrowRightShort
